var promoteCollections = {
  "sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "mens shoes": [
    {
      "title": "Men's Everyday Shoes",
      "link": "https://taosfootwear.com/collections/men"
    }
  ],
  "slippers": [
    {
      "title": "Slip-on Sneakers",
      "link": "https://taosfootwear.com/collections/slip-on-sneakers"
    }
  ],
  "on the double": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "clearance": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "super z": [
    {
      "title": "Active/Outdoor",
      "link": "https://taosfootwear.com/collections/active-outdoor"
    }
  ],
  "women’s sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "white sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "womens sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "mary jane": [
    {
      "title": "Mary Jane Shoes",
      "link": "https://taosfootwear.com/collections/mary-janes"
    }
  ],
  "mens": [
    {
      "title": "Men's Everyday Shoes",
      "link": "https://taosfootwear.com/collections/men"
    }
  ],
  "sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "slip on": [
    {
      "title": "Women's Slip On",
      "link": "https://taosfootwear.com/collections/slip-on"
    }
  ],
  "boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "slides": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "red sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "clogs": [
    {
      "title": "",
      "link": "https://taosfootwear.com/collections/wool"
    }
  ],
  "sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "flats": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "slide": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "navy sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "black sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "navy": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Blue"
    }
  ],
  "taos": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "womens": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "Sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "wedge": [
    {
      "title": "Leather Wedge Sandals",
      "link": "https://taosfootwear.com/collections/wedge-collection"
    }
  ],
  "mary janes": [
    {
      "title": "Mary Jane Shoes",
      "link": "https://taosfootwear.com/collections/mary-janes"
    }
  ],
  "sale sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "clog": [
    {
      "title": "",
      "link": "https://taosfootwear.com/collections/wool"
    }
  ],
  "white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "arch support": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/"
    }
  ],
  "champagne": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Metallics"
    }
  ],
  "leather": [
    {
      "title": "Active Sneakers",
      "link": "https://taosfootwear.com/collections/active"
    }
  ],
  "cork": [
    {
      "title": "Cork Support Sandals",
      "link": "https://taosfootwear.com/collections/cork-support-sandals"
    }
  ],
  "size 12": [
    {
      "title": "Size US 12 / EU 43",
      "link": "https://taosfootwear.com/collections/size-12"
    }
  ],
  "blue sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "slip ons": [
    {
      "title": "Women's Slip On",
      "link": "https://taosfootwear.com/collections/slip-on"
    }
  ],
  "gold": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Metallics"
    }
  ],
  "leather sneakers": [
    {
      "title": "Active Sneakers",
      "link": "https://taosfootwear.com/collections/active"
    }
  ],
  "Show": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sneaker": [
    {
      "title": "Active Sneakers",
      "link": "https://taosfootwear.com/collections/active"
    }
  ],
  "plantar fasciitis": [
    {
      "title": "Active Sneakers",
      "link": "https://taosfootwear.com/collections/active"
    }
  ],
  "silver": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Metallics"
    }
  ],
  "women sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "hiking": [
    {
      "title": "Active/Outdoor",
      "link": "https://taosfootwear.com/collections/active-outdoor"
    }
  ],
  "wide sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "winner": [
    {
      "title": "Active Sneakers",
      "link": "https://taosfootwear.com/collections/active"
    }
  ],
  "gift": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "pewter": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Metallics"
    }
  ],
  "Sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "shoes": [
    {
      "title": "Active Sneakers",
      "link": "https://taosfootwear.com/collections/active"
    }
  ],
  "women’s": [
    {
      "title": "Active Sneakers",
      "link": "https://taosfootwear.com/collections/active"
    }
  ],
  "black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "zipper": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Zipper"
    }
  ],
  "mules": [
    {
      "title": "Women's Slip On",
      "link": "https://taosfootwear.com/collections/slip-on"
    }
  ],
  "ez soul": [
    {
      "title": "Women's Slip On\r",
      "link": "https://taosfootwear.com/collections/slip-on"
    }
  ],
  "heels": [
    {
      "title": "Leather Wedge Sandals",
      "link": "https://taosfootwear.com/collections/wedge-collection"
    }
  ],
  "men": [
    {
      "title": "Men's Everyday Shoes",
      "link": "https://taosfootwear.com/collections/men"
    }
  ],
  "mens sneakers": [
    {
      "title": "Men's Everyday Shoes",
      "link": "https://taosfootwear.com/collections/men"
    }
  ],
  "teal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Green"
    }
  ],
  "Slide": [
    {
      "title": "Women's Slip On",
      "link": "https://taosfootwear.com/collections/slip-on"
    }
  ],
  "moc star": [
    {
      "title": "Active Sneakers",
      "link": "https://taosfootwear.com/collections/active"
    }
  ],
  "womens slippers": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "Wonder": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "wool": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "On the": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "z": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "green": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Green"
    }
  ],
  "canvas": [
    {
      "title": "Active Sneakers",
      "link": "https://taosfootwear.com/collections/active"
    }
  ],
  "dazzle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "plum": [
    {
      "title": "Active Sneakers",
      "link": "https://taosfootwear.com/collections/active"
    }
  ],
  "slipper": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "platform": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "crave": [
    {
      "title": "Crave",
      "link": "https://taosfootwear.com/collections/crave"
    }
  ],
  "white sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "women’s sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "banter": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "mule": [
    {
      "title": "Women's Casual Shoes",
      "link": "https://taosfootwear.com/collections/casuals"
    }
  ],
  "water": [
    {
      "title": "Active/Outdoor",
      "link": "https://taosfootwear.com/collections/active-outdoor"
    }
  ],
  "dress shoes": [
    {
      "title": "Women's Casual Shoes",
      "link": "https://taosfootwear.com/collections/casuals"
    }
  ],
  "size 5": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.v.option.size=A+-+US+5+%28EU+36%29"
    }
  ],
  "fame": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "wide width sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "pink": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Pink"
    }
  ],
  "silver sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "gold sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "olive": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Green"
    }
  ],
  "sandals women": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "hiking sandals": [
    {
      "title": "Active Sandals",
      "link": "https://taosfootwear.com/collections/active-sandals"
    }
  ],
  "socks": [
    {
      "title": "Accessories",
      "link": "https://taosfootwear.com/collections/accessories"
    }
  ],
  "taos sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "walking shoes": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "wedge sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "white sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "Star": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "walking": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Super": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "walking sandals": [
    {
      "title": "Active Sandals",
      "link": "https://taosfootwear.com/collections/active-sandals"
    }
  ],
  "rubber soul": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "ultimate": [
    {
      "title": "Ultimate",
      "link": "https://taosfootwear.com/collections/ultimate"
    }
  ],
  "luckie sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "super": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "shoe": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "White": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "men’s sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "slip on sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "venture sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "wide widths": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women’s shoes": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "black sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "cork sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sand": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "White sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "super z sandals": [
    {
      "title": "Active Sandals",
      "link": "https://taosfootwear.com/collections/active-sandals"
    }
  ],
  "carousel": [
    {
      "title": "Leather Wedge Sandals",
      "link": "https://taosfootwear.com/collections/wedge-collection"
    }
  ],
  "convertawool": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "ez soul slip on sneaker": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "metatarsal support": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sand": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "brown": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "clearance sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "dress sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "inserts": [
    {
      "title": "Sneaker Footbeds",
      "link": "https://taosfootwear.com/collections/accessories/products/active-footbeds"
    }
  ],
  "navy blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "Sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "slide sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "suede": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.material=Suede&filter.p.m.filter.material=Suede+%26+Canvas&filter.p.m.filter.material=Suede+%26+Mesh"
    }
  ],
  "women's sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "yellow sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "buckle": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Adjustable+Buckle"
    }
  ],
  "summer sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "brown sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "Clearance": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "gold sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals on sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "star sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "womens sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Z": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "arch support sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "boot": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "gift 2 sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sideways sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "trophy sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "all mens shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "Black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "Boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "flat": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "footbed": [
    {
      "title": "Sneaker Footbeds",
      "link": "https://taosfootwear.com/collections/accessories/products/active-footbeds"
    }
  ],
  "insoles": [
    {
      "title": "Sneaker Footbeds",
      "link": "https://taosfootwear.com/collections/accessories/products/active-footbeds"
    }
  ],
  "leather sneaker": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneakers with zipper": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "tan sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "wide shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "10 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "blue sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "grey": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Grey"
    }
  ],
  "pink sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Pink"
    }
  ],
  "red sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "size 5 sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "support sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "water sandals": [
    {
      "title": "Active Sandals",
      "link": "https://taosfootwear.com/collections/active-sandals"
    }
  ],
  "wide sandal": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wonderful sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "ballet": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "black sandles": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "booties": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "Canvas": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "champagne sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "guru sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "men’s sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "navy sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "perfect sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "prize 3 sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sale shoes": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "summer clearance": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "tan": [
    {
      "title": "Products\r\n",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "Wedge": [
    {
      "title": "Women's Sandals\r",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "white shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "women sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "women’s boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "Women’s sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Wool": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "zip": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Zipper"
    }
  ],
  "canvas shoes": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "olive green": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Green"
    }
  ],
  "sandals sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "the big time sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "white leather": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "Wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "wool clogs": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "Blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "blue sandles": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "dress flats": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "metallic sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "pewter sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sale items": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "sale sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sale womens": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "sandal sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "stone sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "taos sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "venture sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "waterproof sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "woman’s sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "11w": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "ballet flat": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "canvas sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "dark blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "grey sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Grey"
    }
  ],
  "hiking sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Navy sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "petrol blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "shoes on sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "silver sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "slides on sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "taos sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "teal sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "woman sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "womens sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "wool slippers": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "woolness": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "work shoes": [
    {
      "title": "Women's Casual Shoes",
      "link": "http://taosfootwear.com/collections/casuals"
    }
  ],
  "arch and metatarsal support": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "arch and metatarsal support sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "carousel sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "clear": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "double u sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "hiking sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "mocha sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Off white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "on sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "prize 4 sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "red sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red sandles": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "sale women": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "sandals for women": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals wide width": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "sandals with arch support": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "slide sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "wedge sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "White leather": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white leather sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sandles": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "women's sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "women’s wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "womens wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "Z s": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Zip": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Zipper"
    }
  ],
  "11 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "8 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "ballet flats": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "beige": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "big time wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "black dress shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "blue shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "Boot": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "canvas sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Hiking sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "leather sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Leather sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "men sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "pop soul sneaker": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Red sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "Red sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "sale sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sale sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals clearance": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "size 11 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "size 12 sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "slip in sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "slip on sneaker": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "The show red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "walking sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "walking sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "waterproof sandals": [
    {
      "title": "Leather Wedge Sandals",
      "link": "https://taosfootwear.com/collections/wedge-collection"
    }
  ],
  "white canvas": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "wide sneaker": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women’s sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s sneaker": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "women's wide width": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "work": [
    {
      "title": "Women's Casual Shoes",
      "link": "http://taosfootwear.com/collections/casuals"
    }
  ],
  "xcellent": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "7.5 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "all sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "arch": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "best": [
    {
      "title": "Season's Best!",
      "link": "https://taosfootwear.com/collections/best-sellers"
    }
  ],
  "black and tan sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "black shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black slip on": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "Boo": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "Brown": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "brown leather": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "buckle sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "cherry red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "chit chat flat": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "Clear": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "clearance womens": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "extra wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "final sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "Flats": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "green shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Green"
    }
  ],
  "green sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Green"
    }
  ],
  "it sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "men's sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "my sweet wool": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "navy flats": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "navy sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "olive sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "platform sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "plim soul canvas": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "red shoe": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "sale sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sanda": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals on": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals with back strap": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals womens": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "silver sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "silver sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sneakers sale": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "soul sneaker": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "super z sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "thong sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Wedges": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "white canvas sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "White sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white with lace": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "wide sandles": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "Wide width": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width sandal": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women’s sandals sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s wide sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women’s wide width": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "woolderness": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "Z sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "z strap": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "10w": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "2 sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "6.5 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "7 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "active sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "ankle boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "ankle strap": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "black boots": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black leather sneaker": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "Black sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black slides": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "Black sneaket": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black womens sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "Blue sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "boots women": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "brown sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "brown sandles": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "bruschetta sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "canvas slip on": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "canvas slip ons": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "cherry red sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "Clearance sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "clearance shoes": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "comfort footbed sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "cork wedge sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "crave boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "direction sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "double sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "extra wide shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "final sale sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "flash sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "flat feet": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "gift 2 sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "Hiking sandals": [
    {
      "title": "Leather Wedge Sandals",
      "link": "https://taosfootwear.com/collections/wedge-collection"
    }
  ],
  "it sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Leather white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "light blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "men's sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Metallic sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "metatarsal sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "navy blue sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "Navy sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "navy sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "neutral sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "off white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "olive green shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Green"
    }
  ],
  "Pink": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Pink"
    }
  ],
  "plim soul black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "sale women’s sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal on sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "sandals for": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "sandals women's": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "show sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sneak": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Sneaker": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneakers with zippers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "soft support sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "suede sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "summer sale sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Tan": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "the perfect sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "the show sandals wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "trophy 2 black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "water friendly sandals": [
    {
      "title": "Leather Wedge Sandals",
      "link": "https://taosfootwear.com/collections/wedge-collection"
    }
  ],
  "White dandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white san": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sand": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white with": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white with silver": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white womens sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "wide sneakers": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide womens sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "woman sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "women sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "women’s black sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "women's blue sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "women’s clearance": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "women’s navy sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s sandals with strap": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens black sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "womens dress sand": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens leather sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "womens white sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "womens wide sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "womens wide shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "yellow sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "z sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Z strap": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "zanzibar black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "zipper sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Zipper"
    }
  ],
  "10 w": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "10.5 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "10.5 wide on sale": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "42 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "all day flats": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "all sandles": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "all women’s sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "all womens": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "ankle strap sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "ankle support": [
    {
      "title": "",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "arch support sandal": [
    {
      "title": "",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "Banter": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "best arch support": [
    {
      "title": "Season's Best!",
      "link": "https://taosfootwear.com/collections/best-sellers"
    }
  ],
  "best for": [
    {
      "title": "Season's Best!",
      "link": "https://taosfootwear.com/collections/best-sellers"
    }
  ],
  "big time blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "big time white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "black flats": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black guru": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black leather": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black leather slip on": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black leather sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black stud sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black suede": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black wedge sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black women's sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black womens sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "blue leather": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "blue leather sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "Blue sandaks": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "blue sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "blue women’s sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "boots black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "brown slip ons": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "camel sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Canvas shoes": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "canvas sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "canvas with zipper": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "canvas women": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "carmel and black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "champagne sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "chit chat black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "clearance sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "comfort black leather shoes with lace-up": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "comfort sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "cork wedge": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "covered toe sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "cross sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Dark blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "dark blue sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "dark blue sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "double u black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "double u sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "dress sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "extra wide width": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "ez soul slip on sneaker red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "ez soul sneaker": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "fame sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "final clearance": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "floral sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "footwear women's big time sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "gifts sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "Grey sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Grey"
    }
  ],
  "Hiking sandala": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Leather sneaker": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "luckie sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "maize sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "men boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "men sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "men’s boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "men’s sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "mens boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "mens sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "mens wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "mens wool": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "metallic sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "moc star 2 white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "mocha sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "mule sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "multi colored sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "navy canvas": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "navy leather sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "new sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "new slip on sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "olive boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "olive sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "olive sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "on sale woman": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "on the double sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "petrol blue leather": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "petrol blue sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "plim soul red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "prize 4 sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "prize sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "prize sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "rain boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "red boots": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red leather": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "Red san": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red sneaker": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red women’s casual": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "sage sneakers": [
    {
      "title": "Sneakers with Arch Support",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sale arch support": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "sale on sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sale sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sale walking sandel": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sale women’s": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "sanda": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal size": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal u": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal women": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal z": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals 11 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "sandals blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "sandals in blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "sandals in size 12": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals in wide width": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "sandals men": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals navy": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sandals sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals size 12": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals with backs": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals with studs": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals woman": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sandals. Sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandles women": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sandsls": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "show stopper whites": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "sideway sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sideways sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sideways sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "size 10 clearance": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "size 10 wide width": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "size 12 womens sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "size 36 sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "size 38 sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "size 5 women sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "size 6 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "size 8 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "slide on sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "slide sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "slide show in black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "slide sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "slip on sale clearance": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "slip on sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "slip on sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "slip on sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sneaker mule": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneakers for women": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneakers leather": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneakers on sale": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneakers with arch support": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "soft support sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "star white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "stone sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "strappy sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "summer sandal sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "tan sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "tan sandles": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "taos boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "taos sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "the show black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "the show in wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "toe sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "top shelf sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "travel sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "travel sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "travel sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Trulia sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "walking sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "water proof sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "water sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Water sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Waterproof sandals": [
    {
      "title": "Leather Wedge Sandals",
      "link": "https://taosfootwear.com/collections/wedge-collection"
    }
  ],
  "wedge sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "white leather sneaker": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "White san": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sandals size 8": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sandals women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white slide": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sneaker": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "wide slip on": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width leather": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "Wide width sandal": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width sandles": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width sneakers": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width women sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width women’s sandles": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width women's shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide with womens": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "width womens sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "women arch support sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women flats": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "women wide width": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women's big time sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women's blue sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "women’s brown sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "women's dress sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s flats": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "women’s hiking sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women's navy sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s red sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "women's sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "women’s sale sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s sandal sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s sandals on sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s sandals wide width": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women’s white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "women’s white leather": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "women's wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "womens 10 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "womens flats": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "womens leather sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Womens sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "womens sandals on sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens sandals sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens sandals size": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens sandals strappy": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens slip on sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Womens studded sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens wide width shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wool lining": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "woolflower": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "work it": [
    {
      "title": "Women's Casual Shoes",
      "link": "http://taosfootwear.com/collections/casuals"
    }
  ],
  "woven": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "X": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Xc": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "z 6 sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "z s": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Z sand": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "z sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Zipper": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Zipper"
    }
  ],
  "`high tops": [
    {
      "title": "High Tops",
      "link": "https://taosfootwear.com/collections/high-tops"
    }
  ],
  "1 sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "1 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "10.5 red sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "10.5 sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "10.5 wide shoe": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "10.5 wide women sandle": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "10w women's sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "11 wide sale": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "11 wide sandles": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "11w canvas": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "12 size sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "12 women": [
    {
      "title": "Size US 12 / EU 43",
      "link": "https://taosfootwear.com/collections/size-12"
    }
  ],
  "12 womens": [
    {
      "title": "Size US 12 / EU 43",
      "link": "https://taosfootwear.com/collections/size-12"
    }
  ],
  "13 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "13 wide sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "2 for 100 sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "2 strap sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "3 strap sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "4 sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "5.5 wide shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "6 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "6 wide women’s sandal": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "6.5 wide sneakers": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "6w canvas sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "7 W women’s sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "7 wide sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "8 slide sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "8 wide sandal": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "8 wide sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "8.5 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "9 sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "A sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "a soul women’s sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "adjustable sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "all black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "all black sneaker black sole": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "all black sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "all canvas shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "all footwear in clearance": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "all leather sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "all prize": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "all sa": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "all sandals 9w": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "all shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "all sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "All star": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "all stars": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "All terrain go": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "all wide width shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "all women’s wide sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "am sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Any in green": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Green"
    }
  ],
  "Arch": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "arch & metatarsal suppor": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "arch and heel": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "arch suppor": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "Arch support": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "arch support blue sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "arch support boots": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "arch support insert": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "arch support sandal women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "arch support sandals size 7": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "arch support sandles for women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "arch support shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "arch support shoes plim soul lux": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "Arch support shoes women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "arch support walking sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "arch support white sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "arch support women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "arch support women sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all"
    }
  ],
  "back and sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "back big t": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "back sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "back sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "back strap": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "back women sandal backstrap": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "ball": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Ballet": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "Ban": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "banter black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "banter shoes": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "beige womens": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "best flats": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "best for feet": [
    {
      "title": "Season's Best!",
      "link": "https://taosfootwear.com/collections/best-sellers"
    }
  ],
  "best for walking": [
    {
      "title": "Season's Best!",
      "link": "https://taosfootwear.com/collections/best-sellers"
    }
  ],
  "best hiking sandals": [
    {
      "title": "Leather Wedge Sandals",
      "link": "https://taosfootwear.com/collections/wedge-collection"
    }
  ],
  "Best sandal for bunions": [
    {
      "title": "Season's Best!",
      "link": "https://taosfootwear.com/collections/best-sellers"
    }
  ],
  "best sandles for walking": [
    {
      "title": "Season's Best!",
      "link": "https://taosfootwear.com/collections/best-sellers"
    }
  ],
  "best seller": [
    {
      "title": "Season's Best!",
      "link": "https://taosfootwear.com/collections/best-sellers"
    }
  ],
  "best shoe for europe": [
    {
      "title": "Season's Best!",
      "link": "https://taosfootwear.com/collections/best-sellers"
    }
  ],
  "best shoes for plantar fasciitis": [
    {
      "title": "Season's Best!",
      "link": "https://taosfootwear.com/collections/best-sellers"
    }
  ],
  "best shoes for your feet": [
    {
      "title": "Season's Best!",
      "link": "https://taosfootwear.com/collections/best-sellers"
    }
  ],
  "best walking sandal": [
    {
      "title": "Season's Best!",
      "link": "https://taosfootwear.com/collections/best-sellers"
    }
  ],
  "best walking shoe": [
    {
      "title": "Season's Best!",
      "link": "https://taosfootwear.com/collections/best-sellers"
    }
  ],
  "best womens walking": [
    {
      "title": "Season's Best!",
      "link": "https://taosfootwear.com/collections/best-sellers"
    }
  ],
  "best womens walking shoe": [
    {
      "title": "Season's Best!",
      "link": "https://taosfootwear.com/collections/best-sellers"
    }
  ],
  "Big Time Black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "big time black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "big time in blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "black and": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black and brown": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "black and white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "black ballet": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black canvas": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black dress sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black dress shoes for women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black flat": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black flat sand": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black flat sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black foot bed": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black for women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black hee": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black heels": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "Black hiking Sandler": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black lace up": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "Black leather": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black leather high tops": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black leather sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black leather z soul": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black mary janes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black nubuck": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black on black sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black on sale": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black patent": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black patent leather": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "Black s": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "Black san": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black sandals size 7": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black sandals women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "Black sandle": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "Black sandles": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black shasta": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black shoe": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black shoes women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black size 8": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "Black slides": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "Black sneaker": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black sneaker": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black sneaker with white sole": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "black soles": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black strappy": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black straps": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black venture sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black winner": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black with heel": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black women’s sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black womens": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black z": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black z soul": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "black zip soles": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "bling sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Blue boots": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "blue canvas shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "Blue canvas sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "blue canvas sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "blue dress shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "Blue floral": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "blue leather sandle": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "blue multi sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "Blue sand": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "blue sandals and shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "blue sandals in size 6": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "blue sandals on sale": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "blue shoes for women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "blue sneakers size 10": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "Blue tennis": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "blue thong sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "blue trophy 2": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "Blue wash": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "blue wash canvas": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "blue womens": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "Bo": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "Bootd": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "bootie": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "boots for women": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "boots sale": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "boots with men": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "boots womens": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "brandy sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "bronze sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "brown leather sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "brown leather shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "Brown on the double": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "Brown sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "Brown sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "brown sandals for women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "brown shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "brown size": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "brown women’s sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "buckle sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "campaign color sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "canvas clearance": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "canvas high top sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "canvas high tops": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "canvas high tops sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "Canvas s": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "canvas shoes for women": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "canvas slide": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "canvas slides": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "Canvas sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "canvas sneakers men": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "canvas sneakers navy": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "canvas sneakers plim soul": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "canvas sneakers size 12": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "canvas soul slip": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "canvas walking shoe": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "Canvas washing": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "canvas wide shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "canvas wide women": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "canvas women’s": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "canvas zipper": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "cara sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "caramel sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Caramel sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "caramel sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "carousel 3 black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "carousel 3 black 42": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "carousel sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "carousel white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "casita sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "casual flats": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "casual sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Champagne sandld": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "charcoal sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "cherry red sandles": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "classic white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "clear sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "clearance 8 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "clearance sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "clearance sandals with back": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "clearance sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Clearance size 40": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "clearance sneakers 9": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "clearance the": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "clearance wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "clearance wide width": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "clearance woman’s": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "clearance women": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "clearance women’s 8": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "clearance women’s sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Clogs wool.": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "cognac sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "cognac slide sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "color sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "color sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "colorful women’s sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "colors in on the double sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "comfort sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "comfortable sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "converta wool": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "cool sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "cork bed sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Cork sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "cork sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Cork sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "cork sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "cork sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "cork support sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "cork support sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "cork wedge in white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "Corvo sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "covered sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "covered toe sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "crave red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "cross sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "curve flats": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "daily black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "dark blue bgt-14132": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "dark blue sandals 8 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "dark blue sandles": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "dark blue slide sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "dark red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "dark red womens sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "dark sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "day sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "deep heel sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "distressed black womens": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "does the show come in wide width": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "Double black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "double u clearance": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "double u in black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "double wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "dre’s sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "dress boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "dress whites": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "easy comfortable sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "easy on off slide sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "ecru tan multi": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "elevate white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "everyday sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "extr wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "extra wide width shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "ez soul red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "ez soul red sneaker": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "ez soul sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "fame in tan": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "fame sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "final clearance sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "fit for wide shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "fit sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "flash sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "flash white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "Flat": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "Flat exh": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "flat foot": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "flat foot sandals": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "flat sandals": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "Flatss": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "Flower canvas": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "footbed for sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "for canvas sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "for sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "gel comfort sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "gift 2 black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "Gift 2 sandals pew": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "gift 2 white size 8": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "gift black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "gift sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "gift sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Gold sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "gold sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "graphite sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "graphite/light grey distressed": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Grey"
    }
  ],
  "Green": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Green"
    }
  ],
  "green olive": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Green"
    }
  ],
  "green size 9": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Green"
    }
  ],
  "green womens shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Green"
    }
  ],
  "Grey": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Grey"
    }
  ],
  "grey metallic": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Grey"
    }
  ],
  "grey sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Grey"
    }
  ],
  "grey sandals for women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Grey"
    }
  ],
  "grey shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Grey"
    }
  ],
  "GUR-13472-RED": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "guru in red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "guru red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "guru sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "guru sandal in color": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Guru sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "guru womens sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "high back sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "high canvas": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "high top sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "high top sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Hiking Sandals": [
    {
      "title": "Leather Wedge Sandals",
      "link": "https://taosfootwear.com/collections/wedge-collection"
    }
  ],
  "Honey brown sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "how to clean white canvas": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "laces for sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "lake blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "leather ballet flats": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "leather sandals for women": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "leather sandals womens": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Leather sandl": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "leather slip on sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Leather slip on sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "leather slip on sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Leather sneak": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Leather sneaker for woman": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Leather sneaker with zipper": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "leather sneaker with zipper": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "leather sneakers soul lux 9.5": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "leather sneakers wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "leather sneakers women": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "leather white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "Leather white sneaker": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "Leather white sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "leather wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "leather wide width womens": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "let her sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Light blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "light blue leather": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "light blue sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "light sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "light weight sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "loop blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "low heel boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "luckie sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "luckie sandals for": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "luckie style sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "mary jane ballet flat": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "med blue sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "men sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Men’s canvas shoes": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "men's leather sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "men’s sand": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Men’s sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "men’s sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "men’s shoes sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "men’s slip on sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "men's travel sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "mens boots and shoes": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "mens canvas": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "mens canvas sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "mens clearance": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "mens sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "mens sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "mens sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "mens sneakers leather": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "mens white sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "metallic sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "metallic sandal arch support": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "metatarsal sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "mix sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "moc star 2 white canvas": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "moc star 2 white canvas 7.5": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "moc star white canvas": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "moc star wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "mocha wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "mocha womens sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "most arch support sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "most comfortabl sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "multi sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "natural sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Navy blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "navy blue shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "navy sandals womens": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "navy sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Navy sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "navy sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "navy wedge": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "navy womens sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "new flats with curves": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "new footbed for sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "not sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "off white sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "on sale sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "on sale shoes": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "on size 38 sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "ON THE DOUBLE BLACK": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "On the double brown": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "on the double in tan": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "On the Double sand": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "on the double sandal in": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "on the double sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "on the double sandals for women": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "on the double sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "on the double tan": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "on the double wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "on the go brown": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "on the go sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "or champagne sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "outdoor sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Outdoor womends sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "patent sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "perfect sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "perfect stone sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Perfect tan": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "perfect tan": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "perfect white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "pewter size 9 womens gift 2 sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "pewter sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "pink sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Pink"
    }
  ],
  "plaid sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "plantar fasciitis sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "plantar fasciitis sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "plantar sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Plastic sanda": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "platform sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "plim sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "plim soul blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "plim soul blue wash canvas": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "plim soul grey wash": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Grey"
    }
  ],
  "plim soul grey wash canvas 11 w": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Grey"
    }
  ],
  "plim soul lux women's sneaker size 11": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Plim soul red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "plim soul sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Plim soul Tan": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "plim white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "plim wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "prize 3 prize 4 sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "prize sand": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "proof sneakers for": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "recovery sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "recovery sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "red ankle booties": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "Red b": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "Red canvas shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red canvas sneaker": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red canvas sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red collection": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "Red cork toe loop": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red flats": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red guru": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "Red le": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "Red leather": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red leather shoes womens": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red men’s shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red plim": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "Red sa": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red sa": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "Red sanda": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red sanda": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red sandal size 10": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red sandal\\": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red sandals for women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red sandals size 7": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red sandals size y": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "Red sandels": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "Red sandles": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red sandles on sale": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red show sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red show size 6": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red size 7 sneaker": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red size 8": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "Red sn": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red sneakers size 11 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "red wedge sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red women’s": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "red, white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "removable foot bed sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "removable footbed sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "retro sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "rubber sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "rubber soul white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "rust sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sage color sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sale 10.5": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "sale 6": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "sale canvas": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "sale canvas sneakers 9.5": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "sale casuals": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "sale colors": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "sale da": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "sale footwear": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "sale gift": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "Sale sa": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "Sale san": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "Sale sand": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sale sand": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sale sandals size 7": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sale sandled": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sale size 10 and 11": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "sale size 10 sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sale size 11": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "sale size 8": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "Sale sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sale super": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "sale waterproof sandel": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sale white sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "sale wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "sale women’s shoes": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "sale women's sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Sale womens": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "sale womens sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sale womens sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sale womens size 9": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "sale yellow": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "Sales": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "Sandaks": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal 9": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal 9 sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal big time color": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "sandal clearance": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal footbed": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sandal footbeds": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal for women": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal heel": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal in size 5": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal insoles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal leather z": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sandal sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sandal show": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal size 12": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal slide": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal slides": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "sandal with heel": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandal women buckle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sandald": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals 10.5": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals 36": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals 7w": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals 9w": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals ankle strap": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals ankle support": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals arch support": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals black size 9": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "Sandals blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "sandals cognac": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals cork": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals for jeans": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals for plantar": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals for plantar fasciitis": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals heel": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals in": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals in black for women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "sandals in caramel": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals in cognac": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals in mocha": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals in size": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals olive": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals on sale for women": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "sandals sale size": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals sale size 8": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals show": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals silver": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals size": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals size 12 womens": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals size 40": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals size 42": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals size 5": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals size 8": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals size 8w": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals size 9": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals soft footbed": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals strap": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals strappy": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals super z": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals to wear with a dress": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals walk g": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "sandals with": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals with adjustable leather straps": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals with ankle strap": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sandals with back strap": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals with backstrap": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals with best arch support": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals with bling": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals with embroidery": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals with heel": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals with heel strap": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals with heels": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals with removable footbed": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals with toe ring": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sandals women": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals women wide width": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "sandals women’s": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sandals Z": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandals z": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sandel": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandel sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sandels": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandels": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sandl": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandl sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sandler in black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "sandles colors": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandles for sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandles in teal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandles in wide width": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "sandles new styles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandles tan size 42": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "sandles with arch support": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sandles with back closure": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sandles women": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "serene sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "shoes sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "show red sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "show sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "show stopper sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "show wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "side sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sideway sand": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sideway sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sideway sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sideways blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "sideways leather sandal in": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sideways red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "Sideways tan": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "Silver sandahs": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "size 10 sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "size 10 sale shoes": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "size 10 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "size 10 women's wedges": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "size 11 wide sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "size 12 black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "size 12 black sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "size 12 black womens sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "size 12 sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "size 12 sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "size 12 wide width womens shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "size 12 womens sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "size 42 sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "size 5 sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "size 6 sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "size 6 sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "size 6 wide sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "size 6 wide width sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "size 7 black sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "size 7 wide black sandal": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "size 8 red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "size 8 wide width women's sneakers": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "size 9 sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "size 9 sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "size 9 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "size canvas sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "size for sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "size sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "slide in men's sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "slide in sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "slide in sandals adjustable": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "slide show black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "slide show dark blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "slide show on sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "slide sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "slide white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "slides canvas": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "slip im womens sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "slip in wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "slip on canvas shoes": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "slip on canvas sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "slip on casual red women’s shoe": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "slip on flats": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "slip on leather tan": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "slip on sandals women's": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "slip on sneaker 11": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Slip on sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "slip on sneakers black leather": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "slip on sneakers women": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "slip on women's canvas shoes": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "slip on womens sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "slip ons wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "smooth leather cork wedge sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "sneak": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneaker boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "sneaker brown": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "sneaker footbed": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneaker footbeds": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneaker mens": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneaker red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "sneaker sale": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneaker size 6": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneaker with arch support": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneaker women wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "sneaker womens": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneaker zipper": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneakers 6.5 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "sneakers flat": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "sneakers for": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneakers gold": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneakers green": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Green"
    }
  ],
  "sneakers high top": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneakers in womens 7w": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneakers red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "sneakers sale sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneakers size 12": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneakers size 9.5": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneakers white moc star": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "sneakers wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "sneakers with arch support in canvas": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "sneakers with inner sole": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Sneakers women": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneakers women": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "sneakers womens": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Sneakets": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "soft slip on sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "soft sole sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "soft support sandals trophy 1": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "soul canvas": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "soul clearance": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "soul green": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Green"
    }
  ],
  "soul red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "Sport sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Sport sandel": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "spring sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "star blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "star canvas": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "star canvas sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "star in white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "star sneaker white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "star sneaker women": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "steel sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "steel very sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "step in sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "strappy sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Straw sand": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Studded sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "suede sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "summer boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "Summer clearance": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "summer sale navy blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "summer sandal clearance": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "summer sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "summer sandle collection sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "summer white sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "super clearance": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "super side sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "super sole grey": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Grey"
    }
  ],
  "super soul lake blue/navy": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "super soul sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "Super z sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Super Z sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Super z sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "super z sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "super z tan": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "super z tan multi": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "support sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "supportive sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "tan leather": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "tan leather shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "tan or": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "tan or beige": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "tan sand": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "Tan wedge": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "tan wedge sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "taos all color sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "taos arch support sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "taos black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "taos black shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "taos canvas shoes": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "taos red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "taos red shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "taos sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "taos sale shoes": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "Taos sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Taos sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "taos sandals black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "taos sandals leather": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "taos sandals womens": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "taos sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Taos sandsl": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "taos shoe sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "taos shoes on sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "taos slip on sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "taos sneakers women": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "taos the show red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "Taos Trophy 2 Sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "taos wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "taos wide shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "taos women sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "taos women sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "taos wool slipper": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "Teal sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "teal sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "teal sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Teal sandsl": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "the best arch support sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "the gift sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "The perfect sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "the perfect sandal black size 6": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "the perfect sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "the show 20 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "The show white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "the show white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "the show wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "the show wide width": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "thin sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "thong sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "thong sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "time sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "time sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "toe covered sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "toe guard sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "toe in sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "toe sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "top shelf sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "trophy 2 sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "trophy 2 white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "trulie black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "trulie red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "trulie white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "two strap sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "two tone sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "uru sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "vacation sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "walking sanda": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Walking sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "walking sneakers leather": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "water and hiking sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "water friendly womens sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "water hiking sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "water proof womens sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "water sand": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Water sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "water sandals women": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "water sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Water sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "waterproof sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "waterproof sandal for": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Waterproof sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "waterproof sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "waterproof women’s sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "wedge carousel": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "wedge heel": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "wedge heels": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Wedge in whiye": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "wedge sand": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Wedge sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "wedge sandals white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "Wedge sandle whiye": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "wedgee": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "WEDGES": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "wedges sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "what is the best support sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "what is the best taos sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "white ;eather sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white canvas lace up slip ons": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white canvas shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "White canvas womens": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white cork sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white dress": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white dress sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white flat": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white flats": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white for": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white golden": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white guru sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "White heel": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "White herls": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white high top sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white lace": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white laces": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white leather sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "White leather shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white leather size 11 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "White leather sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white leather wide sneaker": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "White leather z": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "White low wedge": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white on white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "White pl": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white plimsoul": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "White sand": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sandal size 7": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sandal size 8": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sandal slip in": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sandal wedge": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sandals for women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sandals size 11": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sandals size 6": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sandals with heel strap": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sandel": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sandel silver": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sandle": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "White Sandlea": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white size 8 sandles": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "White slide": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white slides": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white slip on": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white slip ons": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "White sneaker": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sneaker women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sneakers clearan ed": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white sneakers wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "white sneakers with zipper": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white soft sandles": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white star": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white star canvas": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white star sneaker": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "White Taos": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white taos sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "White the show slide": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white thong sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white tie sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white wedge": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "White wedges": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white wide sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "white women": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white women sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white women sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white women's sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white womens": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "white womens sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "White womens sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "Whiteb": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "wide 11": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide 39": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide 6.5": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide boots": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide casual shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide clearance": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide feet": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide fit": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "Wide flat sandal": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide in olive": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide leather sneaker": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "Wide mary": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide metatarsal": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "Wide sandal": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide sandal cork": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "Wide sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide sandals or sneakers": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "Wide sandels": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide sandsks": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide shoes for women": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide size 10": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide slip ons": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide styles": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide summer": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide white sandal": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide wide sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width 10 womens": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width active/sneakers": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width black": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width boots": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width foot wear": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "Wide width sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width sandals women": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width slip on": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width taos": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width the show in white": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width trulie": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width women": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width women’s": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width women's sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width womens": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide width. men": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide widthsand": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide with": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide with sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide women": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide women 36": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide women sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide women shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide women’s": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide women’s boot": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide women's sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide women’s sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide women's shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide womens": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "wide,white sale sneakers": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "winner sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "winner white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "woman sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "woman sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "woman’s sale sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "woman’s sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women 7 wide shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women back strap sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women back supportive sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women black sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "women black sandle": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "women black zip": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "women black zip sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "women blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "Women blue boots": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "women brown sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "women brown shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "women clearance": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "women dazzle sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women flat": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "women gold sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women in sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women in sandals camel": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women leather sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women leather sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "women red sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "women sandal sage": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women sandals arch support": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women sandals wide width": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women sandals with removable footbed": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Women sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women sandles size 10": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women shoes wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women shoes wide width": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "Women sideways sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women slip on sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women slip on sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women sneaker with removable footbed": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "women tie sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "women venture sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women walking sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women walking sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Women white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "Women white clogs": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "women white leather sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "women wide sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women wide shoe": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women wide shoe and sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women wide shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women wide width sneakers": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women’s 8 clearance": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "women’s 8 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women’s big time sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "women’s black sandal": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "women's black sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "women’s black shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "women's boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "Women’s boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "women's boots for": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "women's boots with": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "women’s brown sandles": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "women’s canvas": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "women's canvas shoes": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "women’s canvas slip ons": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "Women’s canvas sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "women’s clearance footwear": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "women’s clearance sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s clearance shoes": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "women’s cork sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women's cotton canvas sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "women’s dress sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women's flats": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "women's gift 2 sandal black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "women’s gold sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Women’s grey": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Grey"
    }
  ],
  "women’s grey sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Grey"
    }
  ],
  "women's guru sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s leather hiking sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s leather sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women's metallic sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s mocha sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women's navy sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "women’s red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "women’s red boots": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "Women’s sale 8": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "women’s sale shoes": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "women's sale sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Women’s sand": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Women’s sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Women’s sandal sale 8": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s sandals 10w": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women's sandals blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "Women’s sandals blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "women’s sandals brown": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "women’s sandals clearance": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s sandals flat back strap": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "women's sandals guru": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s sandals in size 12": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women's sandals metatarsal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women's sandals on sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s sandals size 11": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s sandals size 8": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s sandals slip in": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s sandals summer sale": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s sandals wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women’s sandals with adjustable straps": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s sandals with buckles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s sandl": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women's sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s shoes and sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s shoes blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "Women’s silver sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s size 10 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women's size 11 sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s size 11w sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Women’s size 12 sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s slide on sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s slide sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women's slide sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s slide sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Women’s slip on sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "women's sneaker mule": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "women's sneaker with side zipper": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "women's sneakers canvas 9": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/canvas-sneakers"
    }
  ],
  "women's star canvas sneaker size 12 white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "Women’s super z sandals": [
    {
  
    "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women's support sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s tan": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "women’s taos sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s walking sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s walking sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s walking sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "women's walking water sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women's wedge shoes": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "women’s white leather shoes": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "women's white leather sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "Women’s white te": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "women's wide sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women's wide shoe": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women's wide shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women’s wide shoes": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women’s wide sneakers": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women’s wide width in size 12": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women’s wide width sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women’s wide width shoes in stock": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "women’s wide width sneakers": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "Women’s wide widths": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "womens 11 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "Womens ankle boots": [
    {
      "title": "Boots",
      "link": "https://taosfootwear.com/collections/boots"
    }
  ],
  "womens arch support sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens back sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens ballet flat": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "womens black flats": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "womens black leather slides": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "womens brown sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Beige&filter.p.m.filter.color=Brown&filter.p.m.filter.color=Tan"
    }
  ],
  "womens clearance": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "womens clearance shoes": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "womens comfortable sandles with strap": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens cork sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens direction sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "womens dress sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens flat": [
    {
      "title": "Flats",
      "link": "https://taosfootwear.com/collections/supportive-flats"
    }
  ],
  "womens green": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Green"
    }
  ],
  "womens high top sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "womens leather shoes in blue": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "womens leather sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "womens leather white shoe": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "womens navy sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens navy sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "womens on sale": [
    {
      "title": "Clearance",
      "link": "https://taosfootwear.com/collections/clearance"
    }
  ],
  "womens perfect sanda": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens red sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "womens sand": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Womens sandal in blue color": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Blue"
    }
  ],
  "Womens sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens sandals oat": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens sandals size 10 1 w": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens sandals size 6": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens sandals white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "womens sandals wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "womens sandals with": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens sandals with arch support": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens sandle": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens sandles size 12": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens size 12 sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens size 7 sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens size 8 wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "womens slides sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens slip 0n sneaker": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "womens slip on leather sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens slip on sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "womens sneaker with arch support": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "Womens sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "womens sneakers 8.5": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "womens sneakers metatarsal": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "womens sneakers size 9": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "womens suede sneakers": [
    {
      "title": "Women's Canvas Sneakers",
      "link": "https://taosfootwear.com/collections/sneakers"
    }
  ],
  "womens super z sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens wedge": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "womens white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "womens white leather": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "womens white leather sneakers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "womens white support dress shoes and sandals": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "womens wide width": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "womens wide width sandals": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "womens wide widths": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "womens woolness": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "wonder slide black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "wonderful sandal in color": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "wool clog": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "wool footbed": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "Wool slipper": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "wool taos": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "woolder": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "woollery": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "woolnes": [
    {
      "title": "Women's Wool Casuals",
      "link": "https://taosfootwear.com/collections/clogs"
    }
  ],
  "Work": [
    {
      "title": "Women's Casual Shoes",
      "link": "http://taosfootwear.com/collections/casuals"
    }
  ],
  "woven leather": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "woven sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "wrap sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "x sandals": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "X soul lux": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "XC27219ACARA": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Xce": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Xcell": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "XCELLEN": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "XCELLENT": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Xcellent": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "xcellent 2": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "xcellent sandal": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "xtra wide width": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "yellow sandles": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Z sa": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Z san": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "z soul lux black": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all/?filter.p.m.filter.color=Black"
    }
  ],
  "z soul red": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=Red"
    }
  ],
  "Z soul white": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.color=White"
    }
  ],
  "z soul wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "Z str": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "Z stra": [
    {
      "title": "Women's Sandals",
      "link": "https://taosfootwear.com/collections/sandals"
    }
  ],
  "zip bootie": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Zipper"
    }
  ],
  "zip boots": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Zipper"
    }
  ],
  "zip leather": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Zipper"
    }
  ],
  "zip side": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Zipper"
    }
  ],
  "zip side shoe": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Zipper"
    }
  ],
  "zipp": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Zipper"
    }
  ],
  "zipper dress booties": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Zipper"
    }
  ],
  "zipper green": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Zipper"
    }
  ],
  "zipper high tops": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Zipper"
    }
  ],
  "zipper leather": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Zipper"
    }
  ],
  "Zipper s": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Zipper"
    }
  ],
  "zipper sneakers wide": [
    {
      "title": "Wide Width Footwear",
      "link": "https://taosfootwear.com/collections/wide-widths"
    }
  ],
  "Zippered sneaker": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Zipper"
    }
  ],
  "zippers": [
    {
      "title": "Products",
      "link": "https://taosfootwear.com/collections/all?filter.p.m.filter.feature=Zipper"
    }
  ]
};

var promotePages = {
  "luckie": [
    {
      "title": "Luckie Collection",
      "link": "https://taosfootwear.com/pages/luckie-collection"
    }
  ],
  "return policy": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "returns and exchanges": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "return": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "metallic": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=metallic"
    }
  ],
  "soul": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=soul"
    }
  ],
  "mocha": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=mocha"
    }
  ],
  "cognac": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=cognac"
    }
  ],
  "mary": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=mary%20janes"
    }
  ],
  "waterproof shoes": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "floral": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=floral"
    }
  ],
  "stone": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=stone"
    }
  ],
  "caramel": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=caramel"
    }
  ],
  "Mary": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=mary%20jane"
    }
  ],
  "slide on": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=slip%20on"
    }
  ],
  "water shoes": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "bruschetta": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=bruschetta"
    }
  ],
  "Navy": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=navy"
    }
  ],
  "slip": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=slip"
    }
  ],
  "free return": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "Store": [
    {
      "title": "Store Locator",
      "link": "https://taosfootwear.com/pages/store-locator"
    }
  ],
  "returns": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "returns and exchanges policy": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "return bar": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "free returns": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "how to return": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "Waterproof": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "how to return shoes": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "Return": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "Return policy": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "Returns": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "Water": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "waterproof": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "return shoes": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "water shoe": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "women’s waterproof": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "Return polic": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "water proof": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "water proof shoes": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "waterproof hiking": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "waterproof shoe": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "waterproof women": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "waterproof womens": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "women's waterproof": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "cutomer service returns": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "free returns package protection": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "is free returns": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "make a return": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "my returns": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "return form": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "return item": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "return l": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "Return label": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "Return po": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "return policy on": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "returns are": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "returns exchanges": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "returns for": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "returns or exchanges": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "returns policy": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "shasta waterproof": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "shoe return": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "start return": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "taos returns": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "taos shoe return": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "to return shoes": [
    {
      "title": "Return Policy",
      "link": "https://taosfootwear.com/pages/return-policy"
    }
  ],
  "water proff": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "Water resistance": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "water resistance": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "waterproof walking shoes": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "waterproof women’s": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "waterproofing spray": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "women waterproof": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "women waterproof shoes": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "women’s hiking waterproof": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "women’s water shoes": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ],
  "womens waterproof": [
    {
      "title": "search results...",
      "link": "https://taosfootwear.com/pages/search-results-page?q=waterproof%20shoes"
    }
  ]
};